/*by
 zhou.lin
 2016 10 18
 */
"use strict";
angular.module('manageSysManageReleaseComponentManageModule', ['newWindowReleaseComponentManageModule'])
    .controller('manageSysManageReleaseComponentManageCtrl', ['$scope', '$modal', 'trsHttpService', 'globleParamsSet', 'modalDialog', 'trsspliceString', function($scope, $modal, trsHttpService, globleParamsSet, modalDialog, trsspliceString) {
        initStatus();
        initData();
        /**
         * [initStatus description] 默认状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
                "PAGECOUNT": 1
            };
            $scope.status = {
                params: {
                    serviceid: "mlf_publishtag",
                    methodname: "queryTagBeans",
                    CURRPAGE: $scope.page.CURRPAGE,
                    pagesize: $scope.page.PAGESIZE,
                },
                copyCurrPage: 1,
                isESSearch: false,
            };
            $scope.data = {
                items: [],
                selectedArray: []
            };
        }
        /**
         * [initData description] 默认数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }
        /**
         * [requestData description]请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, 'get').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                $scope.data.selectedArray = [];
            });
        }

        /**
         * [new description]新建
         * @return {[type]} [description]
         */
        $scope.new = function() {
            $scope.status.isESSearch = false;
            $scope.status.params.allField = ""; //新建后，显示未检索数据
            createOrEdit({ TAGBEANID: 0 }, "新建");
        };
        /**
         * [xiugai 修改]
         * @return {[type]} [description]
         */
        $scope.xiugai = function(item) {
            createOrEdit(item, "修改");
        };
        /**
         * [createOrEdit 新建或修改]
         * @param  {[object]} item [description] 修改对象
         * @param  {[string]} type [description] 类型
         * @return {[type]} [description]
         */
        function createOrEdit(item, type) {
            windowOpen(item, function(result) {
                var params = {
                    serviceid: "mlf_publishtag",
                    methodname: "saveTagBeans",
                    ObjectId: item.TAGBEANID,
                    TAGNAME: result.TAGNAME,
                    TAGBEAN: result.TAGBEAN,
                    TAGDESC: result.TAGDESC,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get", true).then(function(data) {
                    modalDialog.alertType(type + '成功', "", "success", false, function() {
                        requestData();
                    });
                }, function(data) {
                    if (data.code === "13") {
                        modalDialog.alertType(type + "失败", "没有找到" + result.TAGBEAN + "对应的类", "error", false, function() {
                            requestData();
                        });
                    } else {
                        modalDialog.alertType(data.message, data.detail, "error", false, function() {
                            requestData();
                        });
                    }
                });
            });
        }
        /**
         * [windowOpen description] 新建修改弹窗
         * @return {[type]} [description]
         */
        function windowOpen(item, success) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/releaseComponentManage/newWindowReleaseComponentManage/newWindowReleaseComponentManage.html",
                scope: $scope,
                windowClass: 'new-window-release-component-manage',
                backdrop: true,
                controller: "newWindowReleaseComponentManageCtrl",
                resolve: {
                    Params: function() {
                        return {
                            ObjectId: item.TAGBEANID,
                            TAGNAME: item.TAGNAME,
                            TAGBEAN: item.TAGBEAN,
                            TAGDESC: item.TAGDESC,
                        };
                    }
                },
            });
            modalInstance.result.then(function(result) {
                success(result);
            });
        }
        /**
         * [shareDraft description]删除
         * @return {[type]} [description]
         */
        $scope.shareDraft = function() {
            modalDialog.confirmModal('删除', '确定删除所选组件', function() {
            var params = {
                serviceid: "mlf_publishtag",
                methodname: "deleteTagBeans",
                ObjectIds: trsspliceString.spliceString($scope.data.selectedArray, "TAGBEANID", ","),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    requestData();
                    $scope.data.selectedArray = [];
                });
            });
        };
        /**
         * [fullTextSearch 检索]
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                if ($scope.keywords == " ") {
                    $scope.status.isESSearch = false;
                } else {
                    $scope.status.isESSearch = true;
                    $scope.status.params.allField = $scope.keywords;
                }
                $scope.page.CURRPAGE = 1;
                $scope.status.copyCurrPage = 1;
                requestData();
            }
        };
        /**
         * [refresh description]刷新
         * @return {[type]} [description]
         */
        $scope.refresh = function() {
            $scope.status.isESSearch = false;
            $scope.status.params.allField = ""; //刷新后，显示未检索数据
            $scope.status.params.CURRPAGE = $scope.page.CURRPAGE =1;
            $scope.status.copyCurrPage = 1;
            requestData();
        };
        /**
         * [selectAll description] 列表全选按钮
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };
        /**
         * [selectDoc description] 列表单选按钮
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };
        /** [selectPageNum description] 每页显示的数据数量
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            $scope.status.params.PageSize = $scope.page.PAGESIZE;
            $scope.status.params.CURRPAGE = $scope.page.CURRPAGE;
            requestData();
        };
        /**
         * [selectPageNum description] 选择一页要显示的数据量
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            $scope.status.params.PageSize = $scope.page.PAGESIZE;
            $scope.status.params.CURRPAGE = $scope.page.CURRPAGE;
            requestData();
        };
        /**
         * [pageChanged description] 下一页 页面改变调取数据
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        /**
         * [jumpToPage description] 跳转页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGESIZE) {
                $scope.status.CURRPAGE = $scope.page.PAGESIZE;
            }
            $scope.status.params.CURRPAGE = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.params.CURRPAGE;
            requestData();
        };
        /**
         * [handleTagbean description] 处理tagetbean显示名称
         * @return {[type]} [description]
         */
        $scope.handleTagbean = function(item) {
            var tagbean = item.TAGBEAN.split(".");
            item.TAGBEANSHORTHAND = tagbean[tagbean.length - 1];
        };
    }]);
